// extracted by css-extract-rspack-plugin
var _1 = "confirmation-details__background-extension__v4dBO";
var _2 = "confirmation-details__confirmation-number__Nr27D";
export { _1 as "confirmation-details__background-extension", _2 as "confirmation-details__confirmation-number" }
export default { "confirmation-details__background-extension": _1, "confirmation-details__confirmation-number": _2 }
